import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { filter } from 'rxjs/operators';
import { SEOService } from './SEO.service';
import { defaultLanguage, languages } from '../../../config/ui-config';
import { environment } from '../../../environments/environment';
import { isPlatformBrowser } from '@angular/common';
@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  public languages: string[] = languages;
  public defaultLanguage = defaultLanguage;

  constructor(
    private _translateService: TranslateService,
    private _router: Router,
    private _SEOService: SEOService,
    @Inject(PLATFORM_ID) private platformId: object,
  ) {}

  public init() {
    this._translateService.addLangs(this.languages);
    this._translateService.setDefaultLang(this.defaultLanguage);
    console.log('dev => init()');
    this.listenRouterAndNavigateToDashboard();
    this.listenRouter();
  }

  public languageChange(lang: string): void {
    const urlSegments = this._router.url.split('/');
    urlSegments[1] = lang;
    this._router.navigate([urlSegments.join('/')]);
  }

  private checkLanguage() {
    const validUrl = this._router.url.split('?')[0];
    const urlSegments = validUrl.split('/');
    const langFromUrl = urlSegments[1];
    const isValidLang = this.languages.includes(langFromUrl);
    const isEmptyRoute = urlSegments.every((x) => !x.length);
    if (!isValidLang && !isEmptyRoute) {
      if (validUrl.includes('/dashboard')) {
        this._router.navigate([validUrl]);
        return;
      }
      this._router.navigate([!isValidLang ? '/' : `/${this.defaultLanguage}`]);
    } else if (langFromUrl !== this._translateService.currentLang) {
      this._translateService
        .use(langFromUrl ? langFromUrl : this.defaultLanguage)
        .toPromise()
        .then(() => {
          this._SEOService.setTitleAndMetaTags();
        });
    } else {
      this._SEOService.setTitleAndMetaTags();
    }
  }

  private listenRouter() {
    this._router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.listenRouterAndNavigateToDashboard(event);
        this.checkLanguage();
      });
  }

  public listenRouterAndNavigateToDashboard(event?) {
    if (isPlatformBrowser(this.platformId)) {
      const hasNavigated = event && event.url.includes('/dashboard');
      if (hasNavigated || window.location.href.includes('/dashboard')) {
        setTimeout(() => {
          const url = `${environment.dashboardLoginPageUrl}login/${
            this._translateService.currentLang || 'ka'
          }`;
          window.open(url, '_self');
        }, 1000);
      }
    }
  }
}
